import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const AdminAuthContext = createContext(null);

const api = axios.create({ baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000/api' });

// Attach token to every request
api.interceptors.request.use(config => {
  const token = localStorage.getItem('meridian_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function AdminAuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [token, setToken] = useState(() => localStorage.getItem('meridian_token') || null);

  // Run once on mount to verify the stored token is still valid
  useEffect(() => {
    const stored = localStorage.getItem('meridian_token');
    if (stored) {
      api.get('/auth/me')
        .then(res => {
          setUser(res.data.user);
          setToken(stored);
        })
        .catch(() => {
          localStorage.removeItem('meridian_token');
          setToken(null);
        })
        .finally(() => setLoading(false));
    } else {
      setToken(null);
      setLoading(false);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const login = async (email, password) => {
    const res = await api.post('/auth/login', { email, password });
    localStorage.setItem('meridian_token', res.data.token);
    setToken(res.data.token);
    setUser(res.data.user);
    return res.data.user;
  };

  const logout = () => {
    localStorage.removeItem('meridian_token');
    setToken(null);
    setUser(null);
  };

  return (
    <AdminAuthContext.Provider value={{ user, loading, login, logout, api, token }}>
      {children}
    </AdminAuthContext.Provider>
  );
}

export const useAdminAuth = () => useContext(AdminAuthContext);
export { api };
